import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useIsUpsellScreenEnabled } from '../../hooks';
import { DeliveryCustomization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryScreen = () => {
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationDeliveryScreenRouteParams>();

  const { addressId, productSlug, reorderLineItemId } = routeParams;

  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (isUpsellScreenEnabled) {
      router.replace('/upsell');
      return;
    }

    router.replace({
      pathname: '/bag',
      params: { referrer: 'DeliveryMenu' },
    });
  }, [router, isUpsellScreenEnabled]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      reorderLineItemId={reorderLineItemId}
      onAddLineItemToCart={handleAddLineItemToCart}
      isEditProductMode={false}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationDeliveryScreenRouteParams = {
  addressId: string;
  productSlug: string;
  reorderLineItemId?: string;
};
